//This is shared between Settings and Reports module.

const styles = (theme) => ({
  settingsContainer: {
    borderTop: `1px solid ${theme.AppBGColor}`,
    userSelect: "none",
  },
  leftSection: {
    width: "13%",
    height: "calc(100vh - 98px)",
    boxSizing: "border-box",
    padding: 10,
    borderRight: `1px solid ${theme.AppBGColor}`,
    float: "left",
    // height: "100%",
  },
  reports: {
    [theme.breakpoints.down("md")]: {
      width: "65px",
    },
  },
  reportsListLabel: {
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  rightSection: {
    float: "right",
    width: "87%",
    height: "calc(100vh - 98px)",
    boxSizing: "border-box",
  },
  reportsRightSection: {
    [theme.breakpoints.down("md")]: {
      width: "calc(100% - 65px)",
    },
    height: "100%",
  },
  fullSection: {
    float: "right",
    width: "100%",
    height: "calc(100vh - 98px)",
    boxSizing: "border-box",
  },
  reportsFullSection: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    height: "100%",
  },
  listItemRoot: {
    fontSize: 12,
    padding: 4,
    color: theme.TextColor,
    "&$listItemSelected,&$listItemSelected:hover, &$listItemSelected:focus": {
      color: "white",
      backgroundColor: theme.HeaderSelectedText,
    },
    "&>*": {
      pointerEvents: "none",
    },
  },
  listItemSelected: {
    "& $iconStyle": {
      color: "white",
    },
  },
  iconStyle: {
    marginRight: 20,
    color: theme.HeaderSelectedText,
    fontSize: 18,
  },
  listGroup: {
    color: theme.HeaderSelectedText,
    fontWeight: 600,
  },
  collapseContainer: {
    paddingLeft: 24,
  },
  innerListRoot: {
    padding: 0,
    overflow: "hidden",
  },
  iconRoot: {
    marginRight: 8,
    color: theme.HeaderSelectedText,
    fontSize: 16,
    "&>i::before": {
      margin: 0,
    },
  },
  settingsModuleHeader: {
    color: theme.HeaderSelectedText,
    borderBottom: `1px solid ${theme.AppBGColor}`,
    fontWeight: "bold",
    padding: 10,
    paddingLeft: 22,
    fontSize: 14,
  },
  settingsModuleContent: {
    height: "calc(100% - 40px)",
  },
  reportsListItem: {
    fontSize: 14,
    padding: 6,
    marginBottom: 10,
    [theme.breakpoints.down("md")]: {
      height: "40px",
      padding: "8px",
    },
  },
  card: {
    maxWidth: 300,
    fontSize: "16px",
    fontWeight: "bold",
    color: theme.gridIconBorderColor,
    margin: "0 auto",
    height: 150,
    lineHeight: 7,
    background: theme.ModalBGColor,
    textAlign: "center",
  },
  dcrIcon: {
    transform: "rotate(90deg)",
    fontSize: "18px",
    marginLeft: "6px",
  },
  kpiIcon: {
    fontSize: "18px",
    marginLeft: "6px",
  },
  mergedCustomerIcon: {
    fontSize: "18px",
    marginLeft: "6px",
    transform: "scale(-1,1)",
  },
  extraPadding: { padding: "5px" },
});

export default styles;
